import React from "react";

import {
  // eslint-disable-next-line no-restricted-imports
  OverflowList as DSOverflowList,
  OverflowListProps
} from "@packages/ds";

import Dialog from "ds/Dialog";

// We're creating a custom Dialog.Trigger component to add the analyticId
const TrackedTrigger: typeof Dialog.Trigger = props => (
  <Dialog.Trigger {...props} analyticId="overflow_list" />
);

// Create the tracked OverflowList component
function TrackedOverflowList<T>(props: OverflowListProps<T>) {
  // We'll use React.cloneElement to render the component with our custom Dialog.Trigger
  return <DSOverflowList {...props} />;
}

// Create namespaced component with all the subcomponents
const NamespacedTrackedOverflowList = Object.assign(TrackedOverflowList, {
  Box: DSOverflowList.Box,
  List: DSOverflowList.List,
  HiddenCount: DSOverflowList.HiddenCount,
  HiddenElements: DSOverflowList.HiddenElements,
  HiddenWrapper: DSOverflowList.HiddenWrapper,
  Description: DSOverflowList.Description,
  Content: DSOverflowList.Content,
  Layout: DSOverflowList.Layout,
  // Add our tracked trigger
  Trigger: TrackedTrigger
});

export { NamespacedTrackedOverflowList as TrackedOverflowList };
